import React from 'react';
import * as PropTypes from 'prop-types';
import {PageHeaderInputStyle} from './input.styled';

export const PageHeaderInput = ({
	value,
	placeholder,
	disabled,
	hasError,
	onClick,
	onBlur,
	onChange,
	onKeyDown = () => false,
	callback,
	width,
	maxWidth,
	transition,
	cy,
	innerRef,
}) => {
	const handleOnFocus = e => {
		e.target.select();
	};

	const handleOnClick = e => {
		if (onClick) {
			onClick(e.target);
		}
	};

	const handleOnChange = e => {
		if (onChange) {
			onChange(e.target.value);
		}
	};

	const handleValidate = e => {
		const inputValue = e.target.value;
		if (onBlur) {
			onBlur(e);
		}

		if (callback) {
			// else we just call the mutation;
			callback(inputValue, e);
		}
	};

	const inputState = disabled ? '' : hasError ? ' error' : '';

	return (
		<PageHeaderInputStyle
			className={inputState}
			type={'text'}
			placeholder={placeholder}
			value={value}
			tabIndex={0}
			onFocus={e => handleOnFocus(e)}
			onClick={e => handleOnClick(e)}
			onChange={e => handleOnChange(e)}
			onBlur={e => handleValidate(e)}
			onKeyDown={onKeyDown}
			disabled={disabled}
			width={width}
			data-cy={cy}
			maxWidth={maxWidth}
			ref={innerRef}
			transition={transition}
		></PageHeaderInputStyle>
	);
};

PageHeaderInput.propTypes = {
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,
	/**
	 * This is necessary to get the value of the input from the parent
	 */
	onChange: PropTypes.func,

	/**
	 * Same a the callback prop but only called when typing Enter
	 */
	callbackOnEnter: PropTypes.func,

	/**
	 * Width of the input
	 */
	width: PropTypes.string,

	/**
	 * The caracter limit supported
	 */
	maxWidth: PropTypes.number,

	cy: PropTypes.string,
	onKeyDown: PropTypes.func,
	innerRef: PropTypes.object,
	spanRef: PropTypes.object,
	transition: PropTypes.bool,
};

PageHeaderInput.defaultProps = {
	disabled: false,
	hasError: false,
};
